import React, { useState } from 'react';
import BOOKS from '../data/books';

const GROUPS = [
  { id: 'markets', title: 'Markets and money' },
  { id: 'building', title: 'Building companies' },
  { id: 'more', title: 'Everything else', first: 12 },
];

function Book({ b }) {
  return (
    <a className="book" href={b.url} target="_blank" rel="noopener noreferrer">
      <span className="book-cover">
        <img src={b.cover} alt={b.title || 'Book cover'} loading="lazy" decoding="async" />
      </span>
      {b.title && <span className="book-title">{b.title}</span>}
      {b.author && <span className="book-author">{b.author}</span>}
    </a>
  );
}

// Its own page: the Goodreads shelf, ranked by what matters most to the work.
function Reading() {
  const [all, setAll] = useState(false);
  return (
    <section className="block block-wide page-block" aria-labelledby="reading-title">
      <div className="block-head">
        <h1 id="reading-title">Reading</h1>
      </div>
      {GROUPS.map((g) => {
        const books = BOOKS.filter((b) => b.group === g.id);
        const shown = g.first && !all ? books.slice(0, g.first) : books;
        return (
          <div key={g.id} className="shelf">
            <h2 className="shelf-title">{g.title} <span>{books.length}</span></h2>
            <div className="books">
              {shown.map((b) => <Book key={b.url} b={b} />)}
            </div>
            {shown.length < books.length && (
              <button className="show-all" onClick={() => setAll(true)}>Show all {books.length}</button>
            )}
          </div>
        );
      })}
      <p className="more">Everything I read is on <a href="https://www.goodreads.com/user/show/66639895-nico-p" target="_blank" rel="noopener noreferrer">Goodreads</a>.</p>
    </section>
  );
}

export default Reading;
